import { Injectable } from '@angular/core';
import { LoadIndicatorInterceptor as Interceptor } from '@cuepid/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { LoadIndicatorComponent } from '@cuepid/influencer/shared/components/load-indicator/load-indicator.component';

@Injectable()
export class LoadIndicatorInterceptor extends Interceptor {

  constructor(private readonly dialog: MatDialog) {
    super();
  }

  protected getDialog(): MatDialogRef<any> {
    return this.dialog.open(LoadIndicatorComponent, {
      disableClose: true,
    });
  }
}
